import { render, staticRenderFns } from "./MarkedTagList.vue?vue&type=template&id=09b3cbb8&scoped=true&"
import script from "./MarkedTagList.vue?vue&type=script&lang=js&"
export * from "./MarkedTagList.vue?vue&type=script&lang=js&"
import style0 from "./MarkedTagList.vue?vue&type=style&index=0&id=09b3cbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b3cbb8",
  null
  
)

export default component.exports